/**
 * Created by lu on 2018/4/24.
 */
var nb = require('../nb');
var map = {
    header: {
        homepageText: 'Home',
        brandText: 'Brand',
        productText: 'Product',
        serviceText: 'Service',
        loginText: 'Login',
        languageText: '中文',
        orderText: 'Orders',
        productListText:'Product List',
        invoiceText: 'Invoice History',
        accountText: 'Account Information',
        addressText: 'Shipping Address',
        logOffText: 'Log out',
        goCartText: 'Shopping cart',
        cartTitle: 'Shopping Cart',
        saleTitle: 'Sales service',
        saleName: 'Name：',
        salePhone: 'Phone：',
        saleEmail: 'Email：',
        cartEmptyText: 'There are no items in the shopping cart. Go and see what you want！',
        cartList: {
            itemText: {
                numText: 'Number：',
                priceText: 'Price：'
            }
        }
    },
    notice: {
        noticeList: {
            items: [{
                text: 'Welcome to use ASC business platform. If you have any questions, please contact sales customer service for you.'
            }]
        }
    },
    // sidebar:{
    //     console:'Console'
    // },
    footer: {
        title1: 'About US',
        link1_1: 'Company Profile',
        link1_1_url: 'http://www.asc-wines.com/about/',
        link1_2: 'Social Responsibility',
        link1_2_url: 'http://www.asc-wines.com/about-asc/social-responsibility/',
        link1_3: 'Milestones',
        link1_3_url: 'http://www.asc-wines.com/about-asc/our-leadership/',
        link1_4: 'Executive Team',
        link1_4_url: 'http://www.asc-wines.com/executive-team/',

        title2: 'Services',
        link2_1: 'Events',
        link2_1_url: 'http://www.asc-wines.com/services/events/',
        link2_2: 'ASC Wine Education',
        link2_2_url: 'http://www.asc-wines.com/services/wine-education-2/',
        link2_3: 'En Primeur',
        link2_3_url: 'http://www.asc-wines.com/services/en-primeur/',
        link2_4: 'Wine Auction',
        link2_4_url: 'http://www.asc-wines.com/services/wine-auction/',

        title3: 'Need Help',
        link3_1: 'Contact Us',
        link3_1_url: 'http://www.asc-wines.com/about-asc/contact-us/',
        link3_2: 'Download User Manual',
        link3_2_url: './image/ASC 电商平台使用指南.pdf',

        // aboutUS: 'About US',
        // companyProfile: 'Company Profile',
        // socialResponsibility: 'Social Responsibility',
        // careerDevelopment: 'Career Development',
        // termsConditions: 'Terms Conditions',
        // shoppingHelp: 'Shopping Help',
        // payRelated: 'Pay Related',
        // modeDistribution: 'Mode Distribution',
        // returnWay: 'Return Way',
        // invoiceRelevant: 'Invoice Relevant',
        // needHelp: 'Need Help',
        // contactUs: 'Contact Us',
        // commonProblems: 'Common Problems',
        // shoppingGuide: 'Shopping Guide',
        followUs: 'Follow Us',
        weChat: 'WeChat',
        sinaMicroblog: 'Sina Microblog'

    },
    prompt: {
        successToast: 'Success！',
        failToast: 'Failed，Please try again later！',
        loginSuccessText: 'Login Success！',
        loginFailText: 'Login failed，Please try again later！',
        registerSuccessText: '注册成功！',
        pwdSuccessText: '密码修改成功，请重新登录！',
        orderInvalidText: '抱歉，此订单已失效，请重新下单！',
        agreementText: '请同意协议并勾选！',
        searchWordText: '请填写查询内容！',
        selectDeleteItemText: '请选择需要删除的物品！',
        selectTypeOfCompanyText: '请选择公司类型！',
        selectBusinessLicenseText: '请上传营业执照正面！',
        selectProvinceText: '请选择省！',
        selectCityText: '请选择市！',
        selectAreaText: '请选择区！',
        selectCardTypeText: '请选择证件类型！',
        selectIdCardPositiveText: '请上传身份证正面！',
        selectIdCardReverseText: '请上传身份证反面！',
        selectVoucherPhotoText: '请上传凭证照片！',
    }

};
nb.name('localization.en', map);
module.exports = map;


//////////////////
// WEBPACK FOOTER
// ../src/js/localization/en.js
// module id = 16
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39